@for (toast of toasts(); track toast.id) {
  <article
    class="toast"
    [class.toast--visible]="toast.visible"
    [attr.data-type]="toast.type"
    [attr.role]="toast.visible ? toastRole(toast.type) : null"
    [attr.aria-live]="toast.visible ? toastAriaLive(toast.type) : null"
    [attr.aria-atomic]="toast.visible ? 'true' : null"
    [attr.aria-hidden]="toast.visible ? null : 'true'"
    [attr.data-toast-id]="toast.id"
    #toastRef
  >
    <div class="toast__icon" aria-hidden="true">
      @if (toast.type === ToastType.Success) {
        <mat-icon fontIcon="check_circle"></mat-icon>
      } @else if (toast.type === ToastType.Info) {
        <mat-icon fontIcon="info"></mat-icon>
      } @else if (toast.type === ToastType.Warning) {
        <mat-icon fontIcon="warning"></mat-icon>
      } @else {
        <mat-icon fontIcon="error"></mat-icon>
      }
    </div>
    <div class="toast__content">
      @if (toast.title) {
        <h2 class="toast__title">{{ toast.title }}</h2>
      }
      @if (toast.message) {
        <p class="toast__message">{{ toast.message }}</p>
      }
    </div>
    @if (toast.dismissible) {
      <button
        type="button"
        class="toast__close"
        (click)="dismiss(toast)"
        aria-label="Dismiss notification"
      >
        <span class="toast__close-icon" aria-hidden="true"></span>
      </button>
    }
  </article>
}
